export type NotificationType =
  | 'order'
  | 'inventory'
  | 'pawn'
  | 'workshop'
  | 'system'
  | 'billing';

// ADR-013: snake_case khớp BE response (xem notification-feed.service.ts).
export interface TenantNotification {
  _id: string;
  type: NotificationType;
  title: string;
  body: string;
  read: boolean;
  link?: string;
  created_at: string;
}

export const NOTIFICATION_TYPE_LABEL: Record<NotificationType, string> = {
  order: 'Đơn hàng',
  inventory: 'Kho hàng',
  pawn: 'Cầm đồ',
  workshop: 'Sửa chữa',
  system: 'Hệ thống',
  billing: 'Thanh toán',
};

export const NOTIFICATION_TYPE_COLOR: Record<NotificationType, string> = {
  order: 'blue',
  inventory: 'orange',
  pawn: 'red',
  workshop: 'cyan',
  system: 'default',
  billing: 'purple',
};

const now = Date.now();
const minutesAgo = (m: number) => new Date(now - m * 60_000).toISOString();

export const mockNotifications: TenantNotification[] = [
  { _id: 'n1', type: 'order', title: 'Đơn POS-20260424-0018 hoàn tất', body: 'Tổng 3.200.000₫ — thanh toán tiền mặt.', read: false, link: '/orders', created_at: minutesAgo(5) },
  { _id: 'n2', type: 'inventory', title: 'Cảnh báo tồn kho thấp', body: 'Dây chuyền 24K 2 chỉ chỉ còn 0/3 cái.', read: false, link: '/inventory', created_at: minutesAgo(28) },
  { _id: 'n3', type: 'pawn', title: 'Hợp đồng PD-2604 đến hạn hôm nay', body: 'KH Nguyễn Văn A — 15.000.000₫.', read: false, created_at: minutesAgo(60) },
  { _id: 'n4', type: 'workshop', title: 'Đơn sửa chữa WS-0091 hoàn thành', body: 'Khách Trần Thị B — sẵn sàng giao.', read: false, created_at: minutesAgo(120) },
  { _id: 'n5', type: 'billing', title: 'Gói dùng thử còn 12 ngày', body: 'Nâng cấp để không bị gián đoạn.', read: false, link: '/settings/billing', created_at: minutesAgo(240) },
  { _id: 'n6', type: 'system', title: 'Cập nhật hệ thống v1.8.0', body: 'Thêm phân quyền vai trò tuỳ chỉnh.', read: true, created_at: minutesAgo(600) },
  { _id: 'n7', type: 'order', title: 'Đơn POS-20260423-0012 đã huỷ', body: 'Lý do: khách đổi ý — hoàn trả tiền mặt.', read: true, created_at: minutesAgo(900) },
  { _id: 'n8', type: 'inventory', title: 'Kiểm kê CN Quận 3 hoàn tất', body: 'Chênh lệch: 2 món — xem chi tiết.', read: true, created_at: minutesAgo(1440) },
  { _id: 'n9', type: 'pawn', title: 'Gia hạn PD-2588 thành công', body: 'KH Lê Văn C — thêm 30 ngày.', read: true, created_at: minutesAgo(2880) },
  { _id: 'n10', type: 'order', title: 'Đơn online #OD-2601', body: 'Chờ xác nhận + tạo phiếu giao.', read: true, created_at: minutesAgo(4320) },
  { _id: 'n11', type: 'system', title: 'Đăng nhập mới', body: 'Thiết bị Chrome · TP.HCM.', read: true, created_at: minutesAgo(5760) },
  { _id: 'n12', type: 'billing', title: 'Thanh toán gói thành công', body: 'Gia hạn Professional — 12 tháng.', read: true, created_at: minutesAgo(7200) },
  { _id: 'n13', type: 'workshop', title: 'Đơn sửa WS-0085 nhận đặt', body: 'Khách hẹn lấy 28/04.', read: true, created_at: minutesAgo(10080) },
  { _id: 'n14', type: 'inventory', title: 'Phiếu nhập GR-0312 đã duyệt', body: '15 món — tổng giá 58.000.000₫.', read: true, created_at: minutesAgo(12960) },
  { _id: 'n15', type: 'system', title: 'Backup dữ liệu thành công', body: 'Đã backup 2GB lúc 03:00.', read: true, created_at: minutesAgo(14400) },
];
